import { render, staticRenderFns } from "./TagsManagerListSentimentSelectorDropdown.vue?vue&type=template&id=ead59250&scoped=true"
import script from "./TagsManagerListSentimentSelectorDropdown.vue?vue&type=script&lang=js"
export * from "./TagsManagerListSentimentSelectorDropdown.vue?vue&type=script&lang=js"
import style0 from "./TagsManagerListSentimentSelectorDropdown.vue?vue&type=style&index=0&id=ead59250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead59250",
  null
  
)

export default component.exports